let config = {
                  apiUrl: 'https://shop.kkoester.de/api',
              }
export default config;